import React from 'react';

import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

const Container = styled(Stack)`
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  border-radius: 12px;
  border: 1px solid #3169f6;
  padding: 16px;
`;

const Title = styled(Typography)`
  font-size: 22px;
  font-weight: 400;
  color: #0f1629;
`;

const BoldTitle = styled(Title)`
  font-weight: 700;
`;

const InfoBox = styled(Stack)`
  flex-direction: row;
  align-items: center;
  color: #6c7589;
  font-size: 16px;
`;

const InfoText = styled(Typography)`
  font-style: italic;
`;

export const MasteryHeatMapHeader = () => (
  <Container direction="row">
    <Stack direction="row" spacing={0.75}>
      <BoldTitle>My Daily Progress -</BoldTitle>
      <Title>Lesson Mastered</Title>
    </Stack>
    <InfoBox>
      <CheckRoundedIcon />
      <InfoText>= Daily Target Met</InfoText>
    </InfoBox>
  </Container>
);
